import React, { FC, HTMLAttributes } from 'react'
import { CapacityTableColumns } from '@/root/shared-types'
import cn from 'classnames'
import { ClockIcon } from '@/root/ui/shared/icons/ClockIcon'
import { PassengerIconCyan } from '@/root/ui/shared/icons/PassengerIconCyan'
import { BicycleIcon } from '@/root/ui/shared/icons/BicycleIcon'
import { CarIcon } from '@/root/ui/shared/icons/CarIcon'
import { TruckIconCyan } from '@/root/ui/shared/icons/TruckIconCyan'
import { LocalPassengerIcon } from '@/root/ui/shared'

interface CapacityTableHeadProps extends HTMLAttributes<HTMLDivElement> {
  showColumns: CapacityTableColumns
  warningIconsCountInRow: number
}

export const CapacityTableHead: FC<CapacityTableHeadProps> = ({ showColumns, warningIconsCountInRow }) => {
  const { showPassenger, showResident, showBicycle, showCar, showTruck } = showColumns

  return (
    <div data-testid="ticket-row-header" className="flex h-8 w-full items-center justify-between gap-1">
      <div className="xs:gap-1 flex sm:gap-2">
        <div className="xxs:w-28 ms-2.5 flex w-24 ps-9 sm:w-32">
          <ClockIcon ignoreRtl color="base-normal-lighter" width={17} />
        </div>
        <div
          className={cn({
            'w-5 sm:w-7': warningIconsCountInRow === 1,
            'w-12 sm:w-14': warningIconsCountInRow === 2,
            'w-16 sm:w-20': warningIconsCountInRow === 3,
          })}
        />
      </div>
      {showPassenger && (
        <div className="progress-bar-small flex justify-center">
          <PassengerIconCyan color="base-normal-lighter" width={16} className="xs:w-4 w-3" />
        </div>
      )}
      {showResident && (
        <div className="progress-bar-small flex justify-center">
          <LocalPassengerIcon color="base-normal-lighter" className="xs:w-8 w-7" />
        </div>
      )}
      {showBicycle && (
        <div className="progress-bar-small flex justify-center">
          <BicycleIcon color="base-normal-lighter" width={36} className="xs:w-9 w-7" />
        </div>
      )}
      {(showCar || showTruck) && (
        <div
          className={cn(
            'xs:gap-1.5 flex justify-center gap-1',
            showCar && showTruck ? 'progress-bar-large' : 'progress-bar-small'
          )}
        >
          {showCar && <CarIcon color="base-normal-lighter" width={40} className="xs:w-10 w-7" />}
          {showTruck && <TruckIconCyan color="base-normal-lighter" width={32} className="xs:w-8 w-[22px]" />}
        </div>
      )}
      <div className="xxs:me-2 xxs:w-6 xs:me-4 me-1 w-5 md:w-24 lg:w-6 xl:w-24" />
    </div>
  )
}
